import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // Noise day
    {
      path: '/reports/noise/day/:empid/:year/:month/:day/:culture',
      name: 'noise_day',
      component: () => import('../views/noise_day')
    },
    // Noise month with full date
    {
      path: '/reports/noise/month/:empid/:year/:month/:day/:culture',
      name: 'noise_month',
      component: () => import('../views/noise_month')
    },
    // Noise month strict
    {
      path: '/reports/noise/month/:empid/:year/:month/:culture',
      name: 'noise_month_strict',
      component: () => import('../views/noise_month')
    },
    // Noise year with full date
    {
      path: '/reports/noise/year/:empid/:year/:month/:day/:culture',
      name: 'noise_year',
      component: () => import('../views/noise_year')
    },
    // Noise year strict
    {
      path: '/reports/noise/year/:empid/:year/:culture',
      name: 'noise_year_strict',
      component: () => import('../views/noise_year')
    },
    // Racing day
    {
      path: '/reports/racing/day/:empid/:year/:month/:day/:culture',
      name: 'racing_day',
      component: () => import('../views/racing_day')
    },
    // Racing week
    {
      path: '/reports/racing/week/:empid/:year/:month/:day/:culture',
      name: 'racing_week',
      component: () => import('../views/racing_week')
    },
    // Racing month with full date
    {
      path: '/reports/racing/month/:empid/:year/:month/:day/:culture',
      name: 'racing_month',
      component: () => import('../views/racing_month')
    },
    // Racing month strict
    {
      path: '/reports/racing/month/:empid/:year/:month/:culture',
      name: 'racing_month_strict',
      component: () => import('../views/racing_month')
    },
    // NO2 day
    {
      path: '/reports/no2/day/:empid/:year/:month/:day/:culture',
      name: 'no2_day',
      component: () => import('../views/no2_day')
    },
    // NO2 month with full date
    {
      path: '/reports/no2/month/:empid/:year/:month/:day/:culture',
      name: 'no2_month',
      component: () => import('../views/no2_month')
    },
    // NO2 month strict
    {
      path: '/reports/no2/month/:empid/:year/:month/:culture',
      name: 'no2_month_strict',
      component: () => import('../views/no2_month')
    },
    // NO2 year with full date
    {
      path: '/reports/no2/year/:empid/:year/:month/:day/:culture',
      name: 'no2_year',
      component: () => import('../views/no2_year')
    },
    // NO2 year strict
    {
      path: '/reports/no2/year/:empid/:year/:culture',
      name: 'no2_year_strict',
      component: () => import('../views/no2_year')
    },
    // PF day
    {
      path: '/reports/pf/day/:empid/:year/:month/:day/:culture',
      name: 'pf_day',
      component: () => import('../views/PF_day')
    },
    // PF month with full date
    {
      path: '/reports/pf/month/:empid/:year/:month/:day/:culture',
      name: 'pf_month',
      component: () => import('../views/PF_month')
    },
    // PF month strict
    {
      path: '/reports/pf/month/:empid/:year/:month/:culture',
      name: 'pf_month_strict',
      component: () => import('../views/PF_month')
    },
    {
      path: '/reports/eden/week/:empid/:year/:month/:day/:culture',
      name: 'eden_week',
      component: () => import('../views/eden_week')
    },
    {
      path: '/demo',
      name: 'Demo',
      component: () => import('../views/examples/examples/App')
    },
    {
      path: '/CalibrationUI',
      name: 'Benchmark',
      component: () => import('../views/CalibrationUI')
    },
    {
      path: '/myenv',
      name: 'EnvSettings',
      component: () => import('../views/myenv')
    },
    // ConstructionSite noise day
    {
      path:
        '/reports/ConstructionSiteNoise/day/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_noise_day',
      component: () => import('../views/constructionSite_noise_day')
    },
    // ConstructionSite noise week
    {
      path:
        '/reports/ConstructionSiteNoise/week/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_noise_week',
      component: () => import('../views/constructionSite_noise_week')
    },
    // ConstructionSite vibration day
    {
      path:
        '/reports/ConstructionSiteVibration/day/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_vibration_day',
      component: () => import('../views/constructionSite_vibration_day')
    },
    // ConstructionSite particle week
    {
      path:
        '/reports/ConstructionSiteVibration/week/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_vibration_week',
      component: () => import('../views/constructionSite_vibration_week')
    },
    // ConstructionSite particle day
    {
      path:
        '/reports/ConstructionSiteParticle/day/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_particle_day',
      component: () => import('../views/constructionSite_particle_day')
    },
    // ConstructionSite particle week
    {
      path:
        '/reports/ConstructionSiteParticle/week/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_particle_week',
      component: () => import('../views/constructionSite_particle_week')
    },
    // ConstructionSite bilan week
    {
      path:
        '/reports/ConstructionSiteBilan/week/:affid/:year/:month/:day/:culture',
      name: 'ConstructionSite_bilan_week',
      component: () => import('../views/constructionSite_bilan_week')
    },
    // ConstructionSite affaire fist page week
    {
      path:
        '/reports/ConstructionSiteAffaireFirstPage/week/:affid/:year/:month/:day/:culture',
      name: 'ConstructionSite_affaire_first_page_week',
      component: () =>
        import('../views/constructionSite_affaire_first_page_week')
    },
    // ConstructionSite affaire average week
    {
      path:
        '/reports/ConstructionSiteAffaireAverage/week/:affid/:year/:month/:day/:culture',
      name: 'ConstructionSite_affaire_average_week',
      component: () => import('../views/constructionSite_affaire_average_week')
    },
    // ConstructionSite affaire emplacement week
    {
      path:
        '/reports/ConstructionSiteAffaireEmplacement/week/:empid/:year/:month/:day/:culture',
      name: 'ConstructionSite_affaire_emplacement_week',
      component: () =>
        import('../views/constructionSite_affaire_emplacement_week')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js